<template>
	<input
        v-model="bufferValue"
        type="number"
        class="form-control outline-secondary"
        :placeholder="placeholder"
        @blur = "handlerBlur"
        step="0.01"
        min="0"
        pattern="^\d*(\[.,]\d{0,2})?$"
    >
</template>

<script>
	export default {
		name: 'ReInputDecimal',
		components: {

		},
		props: {
			value: [String,Number], //String, //[String,Number]
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			placeholder: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				bufferValue:'',
                changed: false,
			}
		},
		watch:{
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
			},
			bufferValue(val){  
                this.changed = true;
			},
		},
		computed: {

		},
		methods: {
            handlerBlur(event){
                if(!this.changed) return;
                let val = this.bufferValue
				if(typeof val == 'number') val = val.toString();
				val = this.$GVO.str_replace(' ','',val).replace(',','.');
				//let number1 = this.$GVO.number_format(val,0,'.',' ');
                let number1 = parseFloat(val).toFixed(2);
				if(number1 == 0 ){ number1= ''; }
				this.bufferValue = number1;
				this.$emit("input", this.bufferValue);
                this.changed=false;      
            }			
		},
		mounted() {
			this.bufferValue = this.value;
		}
	}
</script>
<style scoped>

</style>
